<template>

  <div>

      <!-- page-heading -->
      <page-heading :pageTitle="pageTitle" backRoute="pimProducts"></page-heading>

      <tabs type="boxed" size="normal" :on-tab-click="changeTab" :active-index="activeTab">

          <tab-item v-for="tab in tabs" :label="$t(tab.name)" :key="tab.route">
              <router-view :name="tab.name" :key="tab.route" @updatePageTitle="updatePageTitle"></router-view>
          </tab-item>

      </tabs>

  </div>


</template>


<script>

export default {

  name: 'pimProduct',

  data() {

    return {
      activeTab: 0,
      // pageTitle: null,
      tabsRaw: [
        { name: 'PIM-PRODUCT-TAB-DETAIL', routeName: 'pimProductDetail', active: true },
        { name: 'PIM-PRODUCT-TAB-PHARMACY_INFO', routeName: 'pimProductPharmacyInfo', active: true },
        { name: 'PIM-PRODUCT-TAB-LOGS', routeName: 'pimProductLogs', active: true },
      ]
    }

  },

  computed: {

    tabs() {
      return this.tabsRaw.filter(t => t.active == true);
    },

    pageTitle() {
      return this.$store.getters.getPimProductPageTitle;
    }


  },

  /*
  watch: {
    '$route.params.id': function(newId, oldId) {

      console.log("ACHTUNG!")
      if (newId && newId !== oldId) {
        this.initPageTitle();
      }
    }
  },
  */

  async created() {
    
    // hide the "pharmacy info" & "logs" tabs in case we do not have a product id (new product)
    if (!this.$route.params.id || (this.activeUser.userRole.name != 'Administrator' && this.activeUser.userRole.name != 'Administrator JTM')) {

      this.tabsRaw[1].active = false;
      this.tabsRaw[2].active = false;

    } else {

      // this.initPageTitle();
      let x = this.tabs.findIndex(t => t.routeName == this.$route.name);

      if (x == -1) {
        x = 0;
      }

      this.activeTab = x;
      this.$forceUpdate();

    }

  },


  methods: {

    async initPageTitle() {

      console.log("INIT PAGE TITLE");


      /*
      const res = await this.axios.get(this.$config.api + "pimProduct/" + this.$route.params.id);

      let pageTitle = res.data.names && res.data.names.pim && res.data.names.pim != "undefined" && res.data.names.pim != ""
        ? res.data.names.pim
        : res.data.name != "" && res.data.name != null
          ? res.data.name
          : "PIM-PRODUCT-HEADER";

      this.$store.commit('setPimProductPageTitle', pageTitle);
      */



    },

    updatePageTitle(title) {
      if (title) {
        this.$store.commit('setPimProductPageTitle', title);
      }
    },

    changeTab(tab) {

      if (tab != this.activeTab) {
        this.activeTab = tab;
        this.$router.push({ name: this.tabs[tab].routeName });
      }

    }
  }

}

</script>



<style lang="scss">
.tabs {

  .tab-content {

    .tab-pane {

      line-height: 1.2rem;

      a {
        display: inline;
        border: none;
        padding: 0;
        border-radius: 0;

        &:hover {
          background: none;
        }
      }
    }

  }


}
</style>
